import { X, RefreshCw, Send, Mic } from "lucide-react";
import React, { useState } from "react";
import { ActionIcon, Button, Drawer, Text, Textarea } from "@mantine/core";
import { useAIInsightsChat } from "../providers/AIInsightsChatProvider";
import ChatMessageList from "./ChatMessageList";

const AIInsightsChatSidebar: React.FC = () => {
  const {
    isOpen,
    closeChat,
    sendMessage,
    isLoading,
    resetConversation,
    conversationHistory,
  } = useAIInsightsChat();

  const [inputValue, setInputValue] = useState("");
  // const [showCategories, setShowCategories] = useState(false); // For future use

  const handleSend = (): void => {
    if (inputValue.trim() && !isLoading) {
      sendMessage(inputValue);
      setInputValue("");
    }
  };

  const handleKeyPress = (
    event: React.KeyboardEvent<HTMLTextAreaElement>
  ): void => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      handleSend();
    }
  };

  const handleReset = (): void => {
    resetConversation();
    setInputValue("");
  };

  return (
    <Drawer
      opened={isOpen}
      onClose={closeChat}
      position="right"
      size={450}
      padding={0}
      overlayOpacity={0.1}
      overlayBlur={3}
      withCloseButton={false}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
        }}
      >
        {/* Header */}
        <div className="px-4 py-4 border-b border-gray-200">
          <div className="flex items-start justify-between mb-2">
            <div className="flex-1">
              <Text size="xl" weight={700} className="text-jem-primary mb-1">
                Ask Jem
              </Text>
              <Text size="xs" color="dimmed" className="leading-relaxed">
                Curious about trends in your workforce? Ask Jem to show you key
                patterns and stats.
              </Text>
            </div>
            <div className="flex gap-1 ml-2">
              <ActionIcon
                variant="transparent"
                color="gray"
                onClick={handleReset}
                disabled={conversationHistory.length === 0}
                title="Reset conversation"
              >
                <RefreshCw size={18} />
              </ActionIcon>
              <ActionIcon
                variant="transparent"
                color="gray"
                onClick={closeChat}
              >
                <X size={18} />
              </ActionIcon>
            </div>
          </div>
        </div>

        {/* Category Selector - Hidden for now, uncomment when implemented */}
        {/* {showCategories && (
        <>
          <CategorySelector />
          <Divider />
        </>
      )} */}

        {/* Chat Messages */}
        <div className="flex-1 overflow-hidden flex flex-col">
          <ChatMessageList />
        </div>

        {/* Input Area */}
        <div className="border-t border-gray-200 p-4">
          <div className="flex gap-2 items-end">
            <ActionIcon
              variant="transparent"
              color="gray"
              size="lg"
              className="mb-1"
              disabled
              title="Voice input (coming soon)"
            >
              <Mic size={20} />
            </ActionIcon>
            <Textarea
              placeholder="Ask about your team's data..."
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyPress={handleKeyPress}
              disabled={isLoading}
              autosize
              minRows={1}
              maxRows={4}
              className="flex-1"
              styles={{
                input: {
                  borderRadius: "12px",
                },
              }}
            />
            <Button
              onClick={handleSend}
              disabled={!inputValue.trim() || isLoading}
              loading={isLoading}
              className="mb-1"
              style={{
                backgroundColor: "#ED7687",
                borderRadius: "12px",
              }}
              styles={{
                root: {
                  "&:hover": {
                    backgroundColor: "#d86577",
                  },
                },
              }}
            >
              <Send size={18} />
            </Button>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default AIInsightsChatSidebar;
